import { Component, effect, inject, untracked } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateOrderStore } from '@apps/mtjr/vendors/app/orders/create-order.service';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonText,
  IonTextarea,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { VxErrorBarComponent } from '@libs/core/lib/error-view/error-bar.component';
import { NgEventBus } from '@libs/core/lib/event-bus/ng-event-bus';
import { VxSubmitButtonComponent } from '@libs/core/lib/form-controls/mtjr-submit-button.component';
import { VxCurrencyPipe } from '@libs/core/lib/pipes/mtjr-currency.pipe';
import { VxDynamicImageComponent, VxImageComponent } from '@libs/core/lib/shared/mtjr-image.component';
import { AppAlerts } from '@libs/core/lib/utils/app-alerts';
import { Entity, PaymentMethodList } from '@libs/mtjr/shared/generated/types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mav-create-order',
  providers: [],
  imports: [
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonBackButton,
    IonContent,
    IonCard,
    IonText,
    IonButton,
    IonIcon,
    IonItem,
    IonTextarea,
    VxErrorBarComponent,
    VxSubmitButtonComponent,
    VxImageComponent,
    VxCurrencyPipe,
    TranslatePipe,
    FormsModule,
    VxDynamicImageComponent,
  ],
  templateUrl: './create-order.page.html',
})
export class CreateOrderPage {
  store = inject(CreateOrderStore);
  appAlerts = inject(AppAlerts);
  router = inject(Router);
  route = inject(ActivatedRoute);
  eventBus = inject(NgEventBus);
  paymentMethods = PaymentMethodList;
  selectedVariations = new Map<string, Entity.ProductVariation>();

  constructor() {
    effect(() => {
      const orderState = this.store.placeOrderState();
      if (orderState.success) {
        untracked(() => {
          this.appAlerts.successSnackbarTR('ORDERS.ORDER_CREATED_SUCCESS');
          this.store.reset();
          this.router.navigate(['/main/orders', orderState.data.id, orderState.data.subOrders[0].id]);
        });
      }
    });
  }

  getVariationLabel(variation: Entity.ProductVariation): string {
    return variation.attributes.map((attr) => attr.label).join(' / ');
  }

  async submitOrder() {
    if (this.store.selectedItems().length === 0) {
      this.appAlerts.dangerSnackbarTR('ORDERS.NO_PRODUCTS_SELECTED');
      return;
    }
    const confirm = await this.appAlerts.yesNoAlertTR({
      message: 'ORDERS.CREATE_ORDER_CONFIRM',
      header: 'ORDERS.CREATE_ORDER_CONFIRM_HEADING',
      yesCaption: 'COMMON.CONFIRM',
    });

    if (confirm) {
      await this.store.submitOrder(this.store.placeOrder.bind(this.store));
    }
  }
}
